module.exports = __webpack_public_path__ + "static/media/zadania-matematyczne-klasa-5-m4.d01bc149.jpg";